import * as React from 'react';

interface IProps { 
    serial: number;
    type: string;
}

export default class ylkState extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
    }
    public render() {
        return(
            <section className="ylk-edit-state">
                <div className="ylk-state-point" style={{width: `${this.props.type === '1' ? '80%' : '70%'}`}}>
                    <span className="active"></span>
                    <p></p>
                    <span className={this.props.serial > 1 ? 'active' : ''}></span>
                   {
                        this.props.type === '1' ? <p></p> : null
                    }
                    {
                        this.props.type === '1' ? <span className={this.props.serial > 2 ? 'active' : ''}></span> : null
                    }     
                    <p></p>
                    <span className={((this.props.type === '1' && this.props.serial > 3) || (this.props.type !== '1' && this.props.serial > 2)) ? 'active' : ''}></span>
                    {
                        this.props.type === '1' ? <p></p> : null
                    }
                    {
                        this.props.type === '1' ? <span className={this.props.serial > 4 ? 'active' : ''}></span> : null
                    }                    
                </div>
                <div className="ylk-state-text">
                    <p className="active">产品分类</p>
                    <p className={this.props.serial > 1 ? 'active' : ''}>基础描述</p>
                    {
                        this.props.type === '1' ? <p className={this.props.serial > 2 ? 'active' : ''}>技术文档</p> : null
                    }  
                    <p className={((this.props.type === '1' && this.props.serial > 3) || (this.props.type !== '1' && this.props.serial > 2)) ? 'active' : ''}>物性特征</p>
                    {
                        this.props.type === '1' ? <p className={this.props.serial > 4 ? 'active' : ''}>性能参数</p> : null
                    }                    
                </div>
            </section>
        )
    }
}